import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
  Admin,
  AdminSchedule,
  AdminRosterLanding,
  AdminPlayerSeasonMigration,
  AdminRosterTeam,
  AdminLogin,
  AdminDraftOrder,
  AdminGame,
  AdminPlayerExport,
  Archives,
  ArchiveHome,
  ArchiveStats,
  ArchiveTeams,
  ArchiveTeamPageContainer,
  ArchiveSeason,
  ArchiveSeasons,
  HomePage,
  GamePage,
  LoginPage,
  LoadingPage,
  MerchPage,
  PlayerPageContainer,
  RefsPage,
  RinkPage,
  RulesPage,
  SchedulePage,
  ScorekeepingPage,
  StatsPage,
  TeamPageContainer,
} from 'Components';
// require('dotenv').config();

const { REACT_APP_AUTH_COOKIE, REACT_APP_AUTH_TOKEN } = process.env;

const RoutesComponent = () => {
  const authCookie = Cookies.get(REACT_APP_AUTH_COOKIE);

  if (!authCookie || authCookie !== REACT_APP_AUTH_TOKEN) {
    return (
      <Routes>
        <Route index element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="/admin" element={<Admin />}>
        <Route index element={<AdminSchedule />} />
        <Route path="schedule" element={<AdminSchedule />} />
        <Route path="roster" element={<AdminRosterLanding />} />
        <Route path="playerSeasons" element={<AdminPlayerSeasonMigration />} />
        <Route exact path="roster/:id" element={<AdminRosterTeam />} />
        <Route path="login" element={<AdminLogin />} />
        <Route path="draft" element={<AdminDraftOrder />} />
        <Route exact path="game/:id" element={<AdminGame />} />
        <Route path="export" element={<AdminPlayerExport />} />
      </Route>
      <Route path="archives" element={<Archives />}>
        <Route index element={<ArchiveHome />} />
        <Route path="stats" element={<ArchiveStats />} />
        <Route path="teams" element={<ArchiveTeams />} />
        <Route path="team/:id" element={<ArchiveTeamPageContainer />} />
        <Route path="seasons" element={<ArchiveSeasons />} />
        <Route path="season/:id" element={<ArchiveSeason />} />
      </Route>
      <Route exact path="/home" element={<HomePage />} />
      <Route exact path="/rules" element={<RulesPage />} />
      <Route exact path="/refs" element={<RefsPage />} />
      <Route exact path="/scorekeeping" element={<ScorekeepingPage />} />
      <Route exact path="/game/:id" element={<GamePage />} />
      <Route exact path="/player/:id" element={<PlayerPageContainer />} />
      <Route exact path="/rink/:id" element={<RinkPage />} />
      <Route exact path="/schedule/:id" element={<SchedulePage />} />
      <Route exact path="/standings/:id" element={<div>Standings</div>} />
      <Route exact path="/stats/:id" element={<StatsPage />} />
      <Route exact path="/merch" element={<MerchPage />} />
      <Route exact path="/loading" element={<LoadingPage />} />
      <Route
        exact
        path="/team/:seasonId/:teamId"
        element={<TeamPageContainer />}
      />
    </Routes>
  );
};

export default RoutesComponent;
